import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';

type Props = {
    title: string;
    onClick: any;
    startIcon?: JSX.Element | string | undefined;
    sx?: object | undefined;
    fullWidth?: false | boolean;
    disabled?: false | boolean;
    variant?: 'text' | 'contained' | 'outlined';
};

function ButtonGeneral({
    title,
    onClick,
    startIcon,
    sx,
    fullWidth,
    disabled,
    variant = 'contained',
}: Props) {
    return (
        <>
            <Button
                variant={variant}
                type="submit"
                startIcon={startIcon !== undefined ? startIcon : null}
                onClick={onClick}
                disabled={disabled}
                fullWidth={fullWidth}
                sx={sx}
            >
                <Typography
                    component="div"
                    sx={{
                        color: 'primary.contrastText',
                        fontSize: { lg: 14, md: 10.5, xs: 9 },
                    }}
                >
                    {title}
                </Typography>
            </Button>
        </>
    );
}

export default ButtonGeneral;
